module.exports = __webpack_public_path__ + "img/dan.9cb6313f.jpeg";